export default __webpack_public_path__ + "static/media/maintenance.e8f20739.png";